<template>
  <div>
    <app-cells><h1 class="title">Climbing analytics</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'ClimbingAnalyticsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'climbing-analytics-general', label: 'General' },
        { name: 'climbing-analytics-kinapa', label: 'KINAPA' },
      ],
    }
  },
}
</script>
